export default "__VITE_ASSET__DKzJkBRH__"